import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { seoData } from '../data/mock';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import BenefitsSection from '../components/BenefitsSection';
import ClassesSection from '../components/ClassesSection';
import InstructorSection from '../components/InstructorSection';
import GallerySection from '../components/GallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import LocationsSection from '../components/LocationsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { Toaster } from 'sonner';

const LandingPage = () => {
  const { language, t } = useLanguage();

  // Update document title and meta for SEO
  useEffect(() => {
    document.title = t(seoData.titleEn, seoData.titleId);
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = t(seoData.descriptionEn, seoData.descriptionId);

    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = seoData.keywords;

    // Update Open Graph tags
    const ogTags = [
      { property: 'og:title', content: t(seoData.titleEn, seoData.titleId) },
      { property: 'og:description', content: t(seoData.descriptionEn, seoData.descriptionId) },
      { property: 'og:type', content: 'website' },
      { property: 'og:locale', content: language === 'en' ? 'en_US' : 'id_ID' },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, [language, t]);

  return (
    <div className="min-h-screen bg-white">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <BenefitsSection />
        <ClassesSection />
        <InstructorSection />
        <GallerySection />
        <LocationsSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default LandingPage;
